<script setup>
import ServicesFrameworksContent from '../components/ServicesFrameworksContent.vue';
definePageMeta({
  layout: "services-layout",
});
</script>

<template>
    <ServicesFrameworksContent />
</template>